import React from 'react'
import Constant from '../../Constant'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader'
import Moment from 'react-moment'
import axios from 'axios'

class CouponReportList extends React.Component {
  state = {
    couponReportList: [],
    isListLoading: false,
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = async () => {
    this.setState({
      isListLoading: true,
    })

    let couponReportList = await axios.get(Constant.getAPI() + '/admin/get-coupon-report', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (
      couponReportList.status === 200 &&
      couponReportList.data &&
      couponReportList.data.data &&
      couponReportList.data.data.length > 0
    ) {
      this.setState({
        couponReportList: couponReportList.data.data,
        isListLoading: false,
      })
    }
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          filter: false,
          sort: true,
          display: false,
        },
      },
      {
        name: 'coupon_name',
        label: 'Coupon name',
        options: { filter: false, sort: true },
      },
      {
        name: 'coupon_code',
        label: 'Coupon Code',
        options: { filter: false, sort: true },
      },
      {
        name: 'createdAt',
        label: 'Coupon Creation time',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <div>
                <Moment format="DD/MM/YYYY hh:MMA">{value}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'coupon_applied_at',
        label: 'Coupon Applied time',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return <span>{value ? <Moment format="DD/MM/YYYY hh:MMA">{value}</Moment> : '--'}</span>
          },
        },
      },
      {
        name: 'order_number',
        label: 'Order Number',
        options: { filter: false, sort: true },
      },
      {
        name: 'booking_amount',
        label: 'Total Booking Amount',
        options: { filter: false, sort: true },
      },
      {
        name: 'coupon_applied_amount',
        label: 'Coupon Applied Amount',
        options: { filter: false, sort: true },
      },
      {
        name: 'total_booking_amount',
        label: 'After Coupon Applied Amount',
        options: { filter: false, sort: true },
      },
      {
        name: 'deleted_at',
        label: 'Coupon Deleted time',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return <span>{value ? <Moment format="DD/MM/YYYY hh:MMA">{value}</Moment> : '--'}</span>
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: true,
      selectableRows: false,
      filter: false,
      search: true,
      textLabels: {
        body: {
          noMatch: this.state.isListLoading ? <Loader open={this.state.isListLoading} /> : 'Sorry, No Coupon Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Coupons Status Report </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="dt-responsive table-responsive">
                      <MUIDataTable
                        title="Coupons"
                        // title={customToolbar()}
                        className="table-responsive"
                        data={this.state.couponReportList}
                        columns={columns}
                        options={options}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CouponReportList
